export const formTranslationByEdit = (section: string, isEdit?: boolean) => {
  return `${section}.${isEdit ? 'Update' : 'Create'}`;
};
